import { Routes } from '@angular/router';
import { GeaMesLoginComponent, GeaMesCognitoAuthGuard } from '@gea-mes/cognito';

import { AdminComponent } from './admin/components/admin/admin.component';
import { MetricsComponent } from './components/metrics/metrics.component';
import { ObjectListComponent } from './components/object-list/object-list.component';
import { ProblemListComponent } from './components/problem-list/problem-list.component';
import { PaMatrixComponent } from './pa-matrix/components/pa-matrix/pa-matrix.component';
import { InventoryComponent } from './inventory/components/inventory/inventory.component';
import { AnalysisHomeComponent } from './analysis/components/analysis-home/analysis-home.component';
import { PlannedDowntimeComponent } from './components/oa/planned-downtime/planned-downtime.component';
import { CustomerDemandComponent } from './components/oa/customer-demand/customer-demand.component';
import { RootCauseFollowupComponent } from './components/root-cause-followup/root-cause-followup.component';

export const routes: Routes = [
  { path: 'login', component: GeaMesLoginComponent },
  { path: 'objectlist', component: ObjectListComponent, canActivate: [GeaMesCognitoAuthGuard] },
  { path: 'objectlist/:plant_name', component: ObjectListComponent, canActivate: [GeaMesCognitoAuthGuard] },
  {
    path: 'admin',
    canActivate: [GeaMesCognitoAuthGuard],
    children: [
      { path: '', component: AdminComponent },
      { path: 'objectlist', redirectTo: '/admin', pathMatch: 'full' },
      { path: 'problemgroups', redirectTo: '/admin', pathMatch: 'full' },
      { path: 'problems/:problemgroup/:description', redirectTo: '/admin', pathMatch: 'full' },
      { path: 'teamgroups', redirectTo: '/admin', pathMatch: 'full' }
    ]
  },
  {
    path: 'oa',
    canActivate: [GeaMesCognitoAuthGuard],
    children: [
      { path: 'planneddowntime/:site/:objectid', component: PlannedDowntimeComponent },
      { path: 'customerdemand/:site/:objectid', component: CustomerDemandComponent }
    ]
  },
  { path: 'metrics/:site/:objectid', canActivate: [GeaMesCognitoAuthGuard], component: MetricsComponent },
  { path: 'problemlist/:site/:objectid/:hour', canActivate: [GeaMesCognitoAuthGuard], component: ProblemListComponent },
  { path: 'pamatrix/:site/:objectid', canActivate: [GeaMesCognitoAuthGuard], component: PaMatrixComponent },
  { path: 'inventory/:site/:objectid', canActivate: [GeaMesCognitoAuthGuard], component: InventoryComponent },
  { path: 'analysis/:site/:objectid', component: AnalysisHomeComponent },
  { path: 'rootcausefollowup', component: RootCauseFollowupComponent },
  { path: '', redirectTo: '/objectlist', pathMatch: 'full' },
  { path: '**', redirectTo: '/objectlist' }
];